module.exports = __webpack_public_path__ + "img/exa3.45bc0a15.png";